<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div class="page-actions" style="display: flex; justify-content: space-between">
        <div class="select">
          <!-- <div class="item">
            <div class="ipt">
              cdf开关：
              <el-switch v-model="cfdSwitch" active-text="开" inactive-text="关">
              </el-switch>
            </div>
          </div> -->
          <!-- <div class="item">
            <div class="ipt">
              交易开关：
              <el-switch
                v-model="tradeSwitch"
                active-text="开"
                inactive-text="关"
              >
              </el-switch>
            </div>
          </div> -->
          <div class="item">
            <div class="ipt">
              <el-select v-model="tradeSwitch" placeholder="交易对开关" clearable size="mini">
                <el-option v-for="item in tradeSwitchArr" :key="item.value" :label="item.label"
                  :value="item.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-input placeholder="主键ID" clearable v-model="id" size="mini">
              </el-input>
            </div>
          </div>
          <div class="item">
            <div class="ipt">
              <el-select v-model="symbolId" placeholder="交易对ID" size="mini" clearable>
                <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol" :value="item.id">
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button type="primary" @click="handleSearch({ page: 1 })" size="mini">查询</el-button>
          </div>

          <div class="item">
            <el-button type="primary" @click="show('新增')" size="mini">新增交易对</el-button>
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="900">
        <el-table-column prop="symbol" label="交易对" />
        <el-table-column label="CFD滑点" min-width="120">
          <template slot-scope="scope">{{ scope.row.cfdSlippage }}</template>
        </el-table-column>

        <el-table-column label="CFD开关">
          <template slot-scope="scope">
            <span>{{ scope.row.cfdSwitch ? '开' : '关' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="交易开关">
          <template slot-scope="scope">
            <span>{{ scope.row.tradeSwitch ? '开' : '关' }}</span>
          </template>
        </el-table-column>
        <el-table-column label="合约面值">
          <template slot-scope="scope">
            <span>{{ scope.row.contractSize }}</span>
          </template>
        </el-table-column>
        <el-table-column label="价格精度" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.pricePrecision }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最小名义价值" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.minNotional }}</span>
          </template>
        </el-table-column>
        <el-table-column label="最大名义价值" width="120">
          <template slot-scope="scope">
            <span>{{ scope.row.maxNotional }}</span>
          </template>
        </el-table-column>
        <el-table-column prop="liquidationFee" label="强平手续费" />
        <el-table-column prop="makerFee" label="maker费率" />
        <el-table-column prop="takerFee" label="taker费率" />
        <el-table-column prop="rate" label="价格比例" />
        <el-table-column label="创建时间" width="160">
          <template slot-scope="scope">
            <span>{{ scope.row.createdTime | moment }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" width="160">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="show('编辑', scope.row)">编辑</el-button>
            <el-button type="text" size="mini" @click="showBracket(scope.row)">风险限额</el-button>
            <el-button v-if="scope.row.rate" type="text" size="mini"
              @click="showEdit(scope.row.rate, scope.row.symbolId)">修改比例</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination :size="pagination.size" :total="totalCount" :page="pagination.page" @pageChanged="paginationHandle">
      </pagination>

      <el-dialog :title="title" :visible="dialogVisible" width="700px" @close="close" :destroy-on-close="true">
        <el-form ref="CfdDetail" :model="CfdDetail" size="medium" label-width="160px">
          <el-form-item label="CFD开关" prop="">
            <el-switch v-model="CfdDetail.cfdSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="交易开关" prop="">
            <el-switch v-model="CfdDetail.tradeSwitch"> </el-switch>
          </el-form-item>
          <el-form-item label="CFD滑点" prop="">
            <el-input-number :precision="6" :step="0.000001" controls-position="right"
              v-model="cfdTwo"></el-input-number>
            ~
            <el-input-number :precision="6" :step="0.000001" controls-position="right"
              v-model="cfdOne"></el-input-number>
            <div>[0,0.1) 精度6</div>
          </el-form-item>
          <el-form-item label="强平手续费" prop="">
            <el-input-number v-model="CfdDetail.liquidationFee"></el-input-number>
          </el-form-item>
          <el-form-item label="maker费率" prop="">
            <el-input-number v-model="CfdDetail.makerFee"></el-input-number>
          </el-form-item>
          <el-form-item label="taker费率" prop="">
            <el-input-number v-model="CfdDetail.takerFee"></el-input-number>
          </el-form-item>

          <el-form-item label="交易对ID" prop="">
            <el-select v-model="CfdDetail.symbolId" placeholder="交易对ID" clearable>
              <el-option v-for="item in symbolList" :key="item.id" :label="item.symbol" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>

      <!--  修改比例 -->
      <el-dialog title="修改比例" :visible="dialogVisibleEdit" width="400px" @close="dialogVisibleEdit = false"
        :destroy-on-close="true">
        <el-form size="medium" label-width="160px">
          <el-form-item label="价格比例" prop="">
            <el-input-number :step="0.0001" controls-position="right" v-model="rate"></el-input-number>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="dialogVisibleEdit = false">取消</el-button>
          <el-button type="primary" @click="save">确定</el-button>
        </div>
      </el-dialog>
      <!-- 风险限额 -->
      <el-dialog :visible="bracketVisible" center width="80%" title="风险限额" @close="handleClose"
        :destroy-on-close="true">
        <div class="main">
          <el-table :data="bracketList" size="mini" max-height="400px">
            <el-table-column prop="bracket" label="等级" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.bracket }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="symbolId" label="交易对" align="center">
              <template slot-scope="scope">
                <span>{{ findSymbol(scope.row.symbolId) }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="startMarginRate" label="起始保证金率" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.startMarginRate }}</span>
              </template>
            </el-table-column>

            <el-table-column prop="maintMarginRate" label="维持保证金率" align="center">
              <template slot-scope="scope">
                <span>{{ scope.row.maintMarginRate }}</span>
              </template>
            </el-table-column>
            <el-table-column prop="maxLeverage" label="最大杠杆倍数" align="center">
            </el-table-column>

            <el-table-column prop="maxNominalValue" label="最大名义价值" align="center" />
          </el-table>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import api from '../api'
import Pagination from 'components/pagination'
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      // cfdSwitch: false,
      tradeSwitch: '',
      tradeSwitchArr: [
        { label: '开', value: true },
        { label: '关', value: false },
      ],
      id: '',
      symbolList: [],
      symbolId: '',
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: '新增',
      CfdDetail: {
        cfdSlippage: [0.0, 0.0],
        cfdSwitch: false,
        tradeSwitch: false,
        symbolId: '',
        liquidationFee: '',
        makerFee: '',
        takerFee: '',
      },
      cfdOne: 0,
      cfdTwo: 0,
      rate: 1,
      symbolId: '',
      dialogVisibleEdit: false,
      bracketVisible: false,
      bracketList: [],
    }
  },
  computed: {},
  methods: {
    showEdit(rate, id) {
      this.symbolId = id
      this.rate = rate
      this.dialogVisibleEdit = true
    },
    save() {
      api
        .updateContractSymbolPriceRate({
          symbolId: this.symbolId,
          rate: this.rate,
        })
        .then((res) => {
          if (res.code == 0) {
            this.symbolId = ''
            this.rate = 1
            this.dialogVisibleEdit = false
            this.$message.success('操作成功！')
          }
        })
    },

    handleSearch(data = {}) {
      api
        .getContractSymbolPage({
          id: this.id,
          // cfdSwitch: this.cfdSwitch,
          tradeSwitch: this.tradeSwitch,
          id: this.id,
          symbolId: this.symbolId,
          ...this.pagination,
          ...data,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data
            this.tabList = list
            this.totalCount = totalCount
          }
        })
    },
    paginationHandle(pagination) {
      this.pagination = pagination
      this.handleSearch()
    },
    show(str, row) {
      if (row) {
        let arr = JSON.parse(row.cfdSlippage)
        this.CfdDetail = JSON.parse(JSON.stringify(row))
        this.CfdDetail.createdTime = undefined
        this.CfdDetail.updatedTime = undefined
        arr && arr[0] && (this.cfdTwo = arr[0])
        arr && arr[1] && (this.cfdOne = arr[1])
      }
      this.title = str
      this.dialogVisible = true
    },
    showBracket(row) {
      this.bracketVisible = true
      api.getBracke(row.symbolId).then((res) => {
        if (res.code == 0) {
          this.bracketList = res.data
        }
      })
    },
    findSymbol(symbolId) {
      return this.symbolList.find((item) => item.id === symbolId).symbol
    },
    handleClose() {
      this.bracketVisible = false
    },
    close() {
      this.dialogVisible = false
      this.CfdDetail = {
        cfdSlippage: [0.0, 0.0],
        cfdSwitch: false,
        tradeSwitch: false,
        symbolId: '',
        liquidationFee: '',
        makerFee: '',
        takerFee: '',
      }
      this.cfdOne = 0
      this.cfdTwo = 0
    },
    handleSave() {
      if (this.CfdDetail.symbolId == '') {
        return this.$message.error('请选择币种ID')
      }
      api
        .updateContractSymbol({
          ...this.CfdDetail,
          cfdSlippage: JSON.stringify([this.cfdTwo, this.cfdOne]),
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(this.title + '成功')
            this.close()
            this.handleSearch()
          }
        })
    },
  },
  mounted() {
    api.getSymbolList({ type: 'CONTRACT' }).then((res) => {
      if (res.code == 0) {
        this.symbolList = res.data
      }
    })
    this.handleSearch()
  },
}
</script>

<style lang="less" src="../../../styles/button.less" scoped></style>
